// import { ProductCard } from "./ProductCard";

import type { ProductHit } from "../product";
import ProductCard from "../../components/ProductCard";
import { ProductPrice } from "../../components/ProductPrice";

export function ProductHitCard({ productHit, onProductClick }: { productHit: ProductHit, onProductClick?: () => void }) {
  const country = productHit?.named_tags?.country;
  const designer = productHit?.named_tags?.designer;
  const designerName = Array.isArray(designer) ? designer[0] : designer;
  const statusMessage = productHit?.inventory_quantity > 0 ? "Ready to Ship" : "Made to Order";
  const deliveryMessage = productHit?.inventory_quantity > 0 ? "(Delivery 5 - 10 days)" : "(Delivery 18 - 22 weeks)";
  const inStore = productHit?.tags?.some((tag: string) => tag === "non-transactional");
  const badge = productHit?.named_tags?.badge;

  return (
    <ProductCard
      title={productHit.title}
      vendor={productHit.vendor}
      description={
        <ProductPrice variant={productHit} />
      }
      imageSrc={productHit.image}
      imageAlt=""
      link={`/products/${productHit.handle}?variant=${productHit.objectID}`}
      onProductClick={onProductClick}
      badge={badge && <Badge tag={badge} />}
      popOverContent={
        <>
          {country && <p className="tw-text-sm">Handmade in {(country || "").trim()}</p>}

          {inStore && <p className="tw-text-right tw-text-search-grey">Enquire for Price</p>}
          {!inStore && <p className="tw-text-right tw-text-search-grey">{statusMessage}</p>}

          {designerName && typeof designerName === 'string' ? (
            <p className="tw-text-sm">Designed by {designerName.trim()}</p>
          ) : <p></p>}

          {!inStore && <p className="tw-text-right tw-text-search-grey">{deliveryMessage}</p>}
        </>
      }
    />
  )
};

type BadgeProps = {
  tag: string;
};

export const Badge: React.FC<BadgeProps> = ({ tag }) => {
  const badgeParts = tag.split(':');
  const label = badgeParts[0]?.trim();
  const style = badgeParts[1]?.trim();

  if (!label || !style) return null;

  return (
    <span className="inline-flex items-center gap-1">
      <span className={`bullet bullet--${style}`} />
      {label}
    </span>
  );
};